import { ISupplier } from "../../types/supplier.types";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";

const API_URL = import.meta.env.VITE_API_URL;

const makeRequestDebounced = createDebounce(makeRequest, 200);

export async function getSuppliers({
  status = [],
  search = "",
  page = 1,
  itemsPerPage = 10,
  orderBy = "-updatedAt",
  fields = "tradingName, companyName, status, updatedAt, createdAt",
} = {}) {
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    fields,
  });
  let statusParam = "";
  if (Array.isArray(status) && status.length > 0) {
    statusParam = status.join(",");
  } else if (typeof status === "string") {
    statusParam = status;
  }
  status && params.append("filters[status]", statusParam);
  search && params.append("search", search);
  orderBy && params.append("orderBy", orderBy);

  const url = `${API_URL}/suppliers?${params.toString()}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<
    ISupplier[]
  > & { totalItems: number };

  return { ok: result.ok, data: result.data, totalItems: result.totalItems };
}

export async function getAllSuppliers() {
  const url = `${API_URL}/suppliers-all`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<
    ISupplier[]
  >;

  return { ok: result.ok, data: result.data, totalItems: result.data.length };
}

export async function getTotalSuppliers() {
  const suppliersResult = await getSuppliers({ page: 0, itemsPerPage: 0 });

  return suppliersResult.totalItems;
}

export async function getSupplierById(supplierId: string | null) {
  const url = `${API_URL}/suppliers/${supplierId}`;

  const result = (await makeRequestDebounced(url)) as Promise<
    ApiResponseType<ISupplier>
  >;

  return result;
}

export async function createSupplier(data) {
  const url = `${API_URL}/supplier`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<ISupplier>
  >;
}

const removeReadonlyFields = (updatedData) => {
  delete updatedData._id;
};

export async function updateSupplier(id: string, updatedData) {
  // remove readonly fields
  removeReadonlyFields(updatedData);

  const url = `${API_URL}/supplier/${id}`;
  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(updatedData),
  };

  const result = makeRequestDebounced(url, options) as Promise<
    ApiResponseType<ISupplier>
  >;

  return result;
}
